export function platformBrowserColor(theme: 'light' | 'dark', pageStyle: 'classic' | 'island') {
  return pageStyle === 'island' ? '#19363d' : theme === 'dark' ? '#0e1522' : '#f3f5f9';
}
// Temporary game tint; never changes the user's saved theme preference.
let baseColor = '#f3f5f9';
let activeColor: string | null = null;
let gamePageActive = false;
let restoreBackground: (() => void) | null = null;
export function validGameColor(value: unknown): value is string {
  return typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value);
}
function paint() {
  document.documentElement.style.setProperty('--platform-browser-color', baseColor);
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', activeColor || baseColor);
  if (gamePageActive || activeColor) {
    if (!restoreBackground) {
      const saved = [document.documentElement, document.body].map((el) => ({
        el,
        value: el.style.getPropertyValue('background-color'),
        priority: el.style.getPropertyPriority('background-color'),
      }));
      restoreBackground = () =>
        saved.forEach(({ el, value, priority }) =>
          value
            ? el.style.setProperty('background-color', value, priority)
            : el.style.removeProperty('background-color'),
        );
    }
    for (const el of [document.documentElement, document.body])
      el.style.setProperty('background-color', activeColor || baseColor, 'important');
  } else {
    restoreBackground?.();
    restoreBackground = null;
  }
  if (activeColor) document.documentElement.style.setProperty('--game-browser-color', activeColor);
  else document.documentElement.style.removeProperty('--game-browser-color');
}
export function beginGameBrowserTheme() {
  gamePageActive = true;
  activeColor = null;
  paint();
}
export function endGameBrowserTheme() {
  gamePageActive = false;
  activeColor = null;
  paint();
}
export function setPlatformBrowserColor(color: string) {
  baseColor = color;
  paint();
}
export function setGameBrowserColor(color: string | null) {
  if (color !== null && !validGameColor(color)) return;
  activeColor = color;
  paint();
}
export function acceptGameTheme(e: MessageEvent, target: Window | null, origin: string) {
  if (
    !target ||
    e.source !== target ||
    e.origin !== origin ||
    e.data?.type !== 'MOYU_GAME_THEME' ||
    e.data?.version !== 1
  )
    return;
  if (e.data.color === null || validGameColor(e.data.color)) setGameBrowserColor(e.data.color);
}
